import urlJoin from "url-join";

export const extensionsSection = "/extensions";

export const installedExtensionsPath = `${extensionsSection}/`;

export const exploreExtensionsPath = urlJoin(extensionsSection, "explore");
